// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__rtdq8","label":"styles_label__Sr6m9","icon":"styles_icon__DvynK","barIcon":"styles_barIcon__BoX5Y"};